import React from 'react';

import withNewRouter from '~/components/common/higher_order_components/withNewRouter';

import ContentContainer from '../content/content_container';

class AppView extends React.Component {
  content = null;

  setContentRef = content => {
    this.content = content;
  };

  getPosition = () => {
    return this.content.getPosition();
  };

  getRadius = () => {
    return this.content.getRadius();
  };

  render() {
    const {children} = this.props;

    return (
      <>
        <ContentContainer ref={this.setContentRef}>{children}</ContentContainer>
      </>
    );
  }
}

export default withNewRouter(AppView);
